import React from "react";
import { InitiativesIcon } from "assets";

export const INITIATIVES_PAGE = {
    ABSOLUTE_PATH: "/initiatives",
    TITLE: "Initiatives Management",
    SIDEBAR_TITLE: "Initiatives",
    ICON: <InitiativesIcon />,
    renderMenu: false,
    configParameter: "initiative_managament_feature",
    hideInSidebarWhenDisabled: true,
};
